import React from 'react'
import { Icon } from '../../components'
import './Dropdown.css'

class Dropdown extends React.Component {
  state = {
    expanded: false,
    value: this.props.value || this.props.options[0].value,
  }

  componentDidUpdate(props, state) {
    if(props.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  get hasOneOption() {
    return this.props.options.filter(item => !item.disabled).length < 2
  }

  handleToggle = e => {
    if(!this.hasOneOption) {
      this.setState(prevState => ({ expanded: !prevState.expanded }))
    }
  }

  handleSelect = value => {
    this.setState({
      value: value,
      expanded: false,
    }, () => {
      this.props.onChange(this.state.value)
    })
  }

  render() {
    const getCurrentLabel = this.props.options.find(item => item.value === this.state.value).label

    return (
      <div className={`Dropdown${this.state.expanded ? ' is-active' : ''}${this.hasOneOption ? ' has-one-option' : ''}`}
        style={{ maxWidth: '60rem', margin: '0 auto', ...this.props.style}}>
        <div className={`Dropdown-select`} onClick={this.handleToggle}>
          <div className="Dropdown-select-label">
            <label>{this.props.label}</label>
          </div>
          <div className="Dropdown-select-value">
            {getCurrentLabel}
          </div>
          {!this.hasOneOption &&
            <div className="Dropdown-select-icon">
              <Icon name={this.state.expanded ? 'chevron-up' : 'chevron-down'} size="small" />
            </div>
          }
        </div>

        {this.state.expanded &&
          <div className="Dropdown-content">
          {this.props.options.map(item => (
            <div key={item.value}
              onClick={() => this.handleSelect(item.value)}
              className={`${this.state.value === item.value ? 'active' : ''}${item.disabled ? ' disabled' : ''}`}>
              {item.label}
            </div>
          ))}
          </div>
        }
      </div>
    )
  }
}

export default Dropdown
